const Routes = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "status": "الحالة",
    "location": "الموقع",
    "lat": "خط العرض",
    "lng": "خط الطول",
    "search": "بحث",

    // PAGE HEADER
    "routes": "المسارات",

    // ERROR
    "error_name": "يرجى إدخال الاسم",
    "error_desc": "يرجى إدخال الوصف",
    "error_status": "يرجى اختيار الحالة",
    "error_lat": "يرجى إدخال خط العرض",
    "error_lng": "يرجى إدخال خط الطول",
    "error_type_error": "يرجى إدخال أرقام فقط",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_status": "الحالة",
    "table_locations": "المواقع",
    "table_customers": "العملاء",
}

export default Routes